export const HISTORY_ZERO_STATE = {
  session_id: '',
  title: '',
  history: [],
};
